export default __webpack_public_path__ + "static/media/TransportationCars_04.8b72dd29.png";